module.exports = __webpack_public_path__ + "img/icons_14.538aacd4.svg";